// ***LOGOS***
export const logoBlack = "assets/images/logos/logo-black.png";
export const LogoWhite = "../../../assets/images/logos/logo-white.png";
export const BasicLogo = "../../../assets/images/logos/basic-logo.png";
export const Logo = "assets/images/logo.png";
export const IpsoLogo = "../../../assets/images/logos/ipso-regulated.svg";

// ***SOCIAL ICONS***
export const fbIcon = "../../../assets/images/social-icons/fb-icon.svg";
export const InstaIcon = "../../../assets/images/social-icons/insta-icon.svg";
export const twitterIcon = "../../../assets/images/social-icons/twitter-icon.svg";
export const youtubeIcon = "../../../assets/images/social-icons/youtube-icon.svg";
export const linkedinIcon = "../../../assets/images/social-icons/linkedin-icon.svg";

// ***STATIC MEDIA***
export const invalidIcon = "../../../assets/images/invalid-icon.svg";
export const bannerImage = "../../../assets/images/banner-image.png";
export const verifiedImage = "../../../assets/images/signup/verified-img.png";
export const passwordIcon = "../../../assets/images/password-icon.svg";
export const signupTick = "../../../assets/images/signup/signup-tick.png";
export const emailIcon = "../../../assets/images/email-icon.svg";
export const menuIcon = "../../../../assets/images/menu-icon.svg";
export const userProf = "../../../assets/images/user-prof.svg";
export const closeIcon = "../../../../assets/images/close-icon.svg";

// ***DASHBOARD SIDEBAR ICON***
export const dashboardIcon = "../../../../assets/images/icon-dashboard.svg";
export const userIcon = "../../../../assets/images/icon-user.svg";
export const unverifiedUser = "../../../../assets/images/unverified-user.svg"
export const reportsIcon = "../../../../assets/images/reports.svg"
export const subscriptionIcon = "../../../../assets/images/subscription.svg"
